import React, { useContext, useEffect, useState } from "react";
import { Col, Modal, Row } from "reactstrap";
import "./collection.css";
import ProductList from "../../config/productlist.json";
import "../product page/productpage.css";

//CONTEXT
import { AppContext } from "../../contexts/AppContext";
import { ChevronDown, Eye, Minus, Plus, X } from "react-feather";
import { Link } from "react-router-dom";
import { linkToProduct } from "../../utils/utils";
import QuickView from "../quickview/QuickView";
function Collection() {
  const {
    productCollection,
    handleRightDrawer,
    setActiveCollection,
    activeCollection,
    handleAddToCart,
    cartProducts,
    setSelectedProduct,
    toggleQuickViewModal,
    quickViewModal,
  } = useContext(AppContext);
  const [activeIndex, setActiveIndex] = useState();
  const [openCartCaret, setOpenCartCaret] = useState({});
  const [showEyeIcon, setShowEyeIcon] = useState(false); // State to control visibility of the eye icon

  const [quantity, setQuantity] = useState(1);

  useEffect(() => {
    if (window.location.href.includes("collection")) {
      if (
        window.location.pathname
          .split("/")[2]
          ?.split("-")
          .join(" ")
          .toLowerCase() === "all products"
      ) {
        setActiveCollection(ProductList.Products);
      } else if (
        window.location.pathname.split("/")[2]?.includes("best-selling")
      ) {
        const allProducts = ProductList.Products.filter(
          (products) => products?.["best-selling"] === true
        );

        setActiveCollection(allProducts);
      } else {
        const allProducts = ProductList.Products.filter(
          (products) =>
            products?.category.toLowerCase() ===
            window.location.pathname.split("/")[2]?.split("-").join(" ")
        );

        setActiveCollection(allProducts);
      }
    }
  }, [productCollection, setActiveCollection]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (cartProducts?.length && openCartCaret?.name) {
      const filterProduct = cartProducts.filter(
        (product) => product.name === openCartCaret.name
      );

      if (filterProduct?.length) {
        setQuantity(filterProduct[0].quantity);
      } else {
        setQuantity(1);
      }
    } else {
      setQuantity(1);
    }
  }, [cartProducts, openCartCaret]);
  return (
    <>
      <Row className="coltn_wrapper justify-content-center px-2">
        <Col md={5} className="coltn_wrapper_col text-center">
          <b>
            {window.location.pathname
              .split("/")[2]
              ?.split("-")
              .join(" ")
              ?.toUpperCase() ?? "hdgjkhkj "}
          </b>
          <p>
            Shop our efficacious, transparent, and research-backed range of
            skincare & haircare products. Each product is formulated to target
            your specific skin or hair concerns.
          </p>
        </Col>

        {/* collection filter   */}
        <Col md={10} className="clctn_filter_wrapper">
          <Row className="clctn_filtr_bar">
            <Col className="d-flex justify-content-start">
              <div
                className="filter_btn"
                onClick={() => handleRightDrawer("Filter")}
              >
                <Row className="justify-content-center">
                  <Col>
                    <p>Filter</p>{" "}
                  </Col>
                  <Col>
                    <ChevronDown color="#d4d4d4" />
                  </Col>
                </Row>
              </div>
            </Col>

            <Col className="d-flex justify-content-end">
              <div
                className="filter_btn"
                onClick={() => handleRightDrawer("Sort")}
              >
                <Row className="justify-content-center">
                  <Col>
                    <p>Sort</p>{" "}
                  </Col>
                  <Col>
                    <ChevronDown color="#d4d4d4" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <hr />
          <Row className="product_list_wrapper">
            {activeCollection?.map((product, i) => {
              return (
                <Col md="4" xs={6} className="mb-4" key={product.name + i}>
                  <div
                    onMouseEnter={(e) => {
                      setActiveIndex(i);
                      setOpenCartCaret(product);
                      setShowEyeIcon(true); // Set showEyeIcon to true when mouse enters
                    }}
                    onMouseLeave={() => {
                      setActiveIndex();
                      setOpenCartCaret();
                      setShowEyeIcon(false); // Set showEyeIcon to false when mouse leaves
                    }}
                  >
                    <>
                      <span className="image-container">
                        <Link
                          className="link_product"
                          to={`${linkToProduct(product)}`}
                        >
                          <img
                            width="100%"
                            src={`/${product.images[0]}`}
                            alt={product.name}
                          />
                        </Link>

                        {i === activeIndex && showEyeIcon && (
                          <div
                            className="eye-icon-overlay"
                            style={{
                              display: i === activeIndex ? "flex" : "none",
                            }}
                            onClick={() => {
                              setSelectedProduct([product]);
                              toggleQuickViewModal();
                            }}
                          >
                            <Eye
                              className="cursor-pointer text-white"
                              width={"18px"}
                            />
                          </div>
                        )}
                      </span>

                      <Col className="carousel_productinfo text-center">
                        <p className="carousel_product_name">{product?.name}</p>
                        <p className="carousel_card_mrp mb-0">
                          {product?.reviewers[0].count}
                        </p>
                        <Row>
                          <p className="carousel_card_mrp mt-0">
                            {product?.mrp}
                            <span className="carousel_card_price mt-0">
                              {product?.offerPrice}
                            </span>
                          </p>
                        </Row>
                      </Col>
                      {i === activeIndex && (
                        <Row
                          // className={`cart_show ${
                          //   activeIndex ? "visible" : "hidden"
                          // }`}
                          className={`cart_show ${"visible"}`}
                        >
                          <Col xs={12} sm={4} md={4} className="px-0">
                            <Row className="quntyty_clctn_cntnr">
                              <Col className="quntyty_clctn_box" sm={4} md={4}>
                                <Minus
                                  className="cursor-pointer"
                                  width={"18px"}
                                  onClick={() => {
                                    if (quantity > 1) {
                                      setQuantity(quantity - 1);
                                    }
                                  }}
                                />
                              </Col>
                              <Col
                                className="quntyty_clctn_box text-center"
                                sm={4}
                                md={4}
                              >
                                {quantity}
                              </Col>
                              <Col className="quntyty_clctn_box" sm={2} md={2}>
                                <Plus
                                  className="cursor-pointer"
                                  width={"18px"}
                                  onClick={() => {
                                    setQuantity(quantity + 1);
                                  }}
                                />
                              </Col>
                            </Row>
                          </Col>
                          <Col sm={8} md={8}>
                            <Row>
                              <button
                                className="addcart_clctn_page bg-dark text-white border-0"
                                onClick={() => {
                                  handleAddToCart(
                                    product?.name,
                                    product?.offerPrice,
                                    quantity,
                                    product?.images[0],
                                    product?.id
                                  );
                                }}
                              >
                                Add to cart
                              </button>
                            </Row>
                          </Col>
                        </Row>
                      )}
                    </>
                  </div>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>
      <Modal
        size="xl"
        centered
        isOpen={quickViewModal}
        toggle={toggleQuickViewModal}
      >
        <QuickView
          toggleQuickViewModal={toggleQuickViewModal}
          quickViewModal={quickViewModal}
        />
      </Modal>
    </>
  );
}

export default Collection;
